var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-scale-transition", [
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "big-snackbar elevation-1",
            class: {
              "snack-success": _vm.snack.status === "success",
              "snack-default":
                _vm.snack.status === "default" || !_vm.snack.status,
              "snack-danger": _vm.snack.status === "danger",
              "snack-warning": _vm.snack.status === "warning"
            }
          },
          [
            _vm.icon
              ? _c(
                  "v-icon",
                  {
                    staticStyle: { color: "inherit" },
                    attrs: { size: "24px" }
                  },
                  [_vm._v(" " + _vm._s(_vm.icon) + " ")]
                )
              : _vm._e(),
            _c("div", { staticClass: "big-snackbar-content" }, [
              _vm._v(" " + _vm._s(_vm.snack.text || "") + " ")
            ]),
            _c("v-spacer"),
            _vm.snack.close
              ? _c(
                  "v-btn",
                  {
                    staticStyle: { color: "inherit" },
                    attrs: { icon: "", small: "" },
                    on: { click: _vm.close }
                  },
                  [
                    _c("icon-svg", {
                      staticStyle: { color: "inherit" },
                      attrs: { size: "12", name: "close" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }